var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const Svg2Tickets = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.55556 5.33366H12.4444V10.667H3.55556V5.33366ZM14.6667 8.00033C14.6667 8.73671 15.2636 9.33366 16 9.33366V12.0003C16 12.7367 15.4031 13.3337 14.6667 13.3337H1.33333C0.596944 13.3337 0 12.7367 0 12.0003V9.33366C0.736389 9.33366 1.33333 8.73671 1.33333 8.00033C1.33333 7.26394 0.736389 6.66699 0 6.66699V4.00033C0 3.26394 0.596944 2.66699 1.33333 2.66699H14.6667C15.4031 2.66699 16 3.26394 16 4.00033V6.66699C15.2636 6.66699 14.6667 7.26394 14.6667 8.00033ZM13.3333 5.11144C13.3333 4.74324 13.0349 4.44477 12.6667 4.44477H3.33333C2.96514 4.44477 2.66667 4.74324 2.66667 5.11144V10.8892C2.66667 11.2574 2.96514 11.5559 3.33333 11.5559H12.6667C13.0349 11.5559 13.3333 11.2574 13.3333 10.8892V5.11144Z",
    fill: "#9FA2B4"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2Tickets, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2. tickets.36295275.svg";
export { ForwardRef as ReactComponent };